import { apiUrl } from "./constants.ts";

export const serverConfig = {
  serverUrl: apiUrl || "https://testproyect100new.online:9001", // Mantenemos el puerto para el backend
  // Cambiado a wss:// y sin puerto, Nginx maneja SSL en 443
  livekitWsUrl: "wss://testproyect100new.online"
};

export const sendModeratorAlert = async (ownerAddress: string, reason: string) => {
  try {
    const response = await fetch(`${serverConfig.serverUrl}/report-nsfw`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ownerAddress, reason }),
    });
    if (!response.ok) throw new Error("Failed to notify moderators");
    const data = await response.json();
    console.log(`Moderators alerted for ${ownerAddress}: ${reason}`);
    return data.banned;
  } catch (error) {
    console.error("Error alerting moderators:", error);
    return false;
  }
};

export const isStreamPaused = async (ownerAddress: string): Promise<boolean> => {
  try {
    const response = await fetch(`${serverConfig.serverUrl}/check-ban/${ownerAddress}`);
    const data = await response.json();
    return data.banned;
  } catch (error) {
    console.error("Error checking ban status:", error);
    return false;
  }
};

export const checkStreamForNSFW = async (streamUrl: string, ownerAddress: string): Promise<boolean> => {
  try {
    const response = await fetch(`${serverConfig.serverUrl}/check-nsfw`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ streamUrl, ownerAddress }),
    });
    if (!response.ok) throw new Error("Failed to initiate NSFW check");
    const data = await response.json();
    console.log(`NSFW check initiated for ${ownerAddress}:`, data);
    return false; // Banning happens via server callback
  } catch (error) {
    console.error("Error checking NSFW:", error);
    return false;
  }
};